import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

/**
 * Simple hook for CRUD list + fetch.
 * endpoint: like "/pacientes"
 */
export function useCrudList(endpoint, params = {}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchList = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(endpoint, { params });
      setItems(Array.isArray(data) ? data : data.items || []);
      setError(null);
    } catch (e) {
      const msg = formatApiErrorDetail(e.response?.data?.detail) || e.message;
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, JSON.stringify(params)]);

  return { items, loading, error, refetch: fetchList, setItems };
}

export async function crudCreate(endpoint, payload) {
  const { data } = await api.post(endpoint, payload);
  return data;
}

export async function crudUpdate(endpoint, id, payload) {
  const { data } = await api.patch(`${endpoint}/${id}`, payload);
  return data;
}

export async function crudDelete(endpoint, id) {
  const { data } = await api.delete(`${endpoint}/${id}`);
  return data;
}
